import { Component, Inject, OnInit, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AcumaticaService } from '../acumatica.service';

@Component({
  selector: 'acumatica-login',
  templateUrl: './acumatica-login.component.html',
  styleUrls: ['./acumatica-login.component.css']
})
export class AcumaticaLoginComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      errorMessage: string
    },
    private acumatica: AcumaticaService,
    private router: Router
  ) { }

  errorMessage: string = "";
  isLoading = false;

  ngOnInit(): void {
    if (this.acumatica.username) {
      // user is logged in already
      this.LoggedIn.emit(null);
    }

    if (this.data && this.data.errorMessage) this.errorMessage = this.data.errorMessage;
  }

  @Output() LoggedIn = new EventEmitter<any>();

  doLogin(credentials: any) {
    this.isLoading = true;
    this.acumatica.Login(credentials.username, credentials.password)
      .subscribe(
        result => {
          if (result.loggedin) {
            this.LoggedIn.emit(null);
          } else {
            this.errorMessage = result.error || "Something unexpected went wrong";
          }
          this.isLoading = false;
        },
        error => {
          this.errorMessage = error.message;
        }
      );
  }
}
